import { updateApplicantsAction } from 'ducks/applicantsLessonStatus';
import { getApplicantAction } from 'ducks/workItem';
import orderBy from 'lodash/orderBy';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import * as Table from 'reactabular-table';
import { Flex } from 'rebass';
import { bindActionCreators } from 'redux';
import * as sort from 'sortabular';
import { PvCaret} from 'styles/CustomComponents';
import * as resolve from 'table-resolver';
import { ApplicantName } from '../../styles/CustomComponents';
import { formatShortLessonDescription, jsxJoinWith } from '../../util/FormatUtil';
import hasRole from '../../util/hasRole';
import { PvRadioButton } from '../form/PvRadioButton';

class UndoneDataTable extends React.Component {
  constructor(props) {
    super(props);
    const getSortingColumns = () => this.state.sortingColumns || {};

    const toggleSelection = (applicant) => {
      // Reset selections
      const applicants = this.props.rows.map(a => Object.assign(a, {selected: false}));
      const i = applicants.map((a) => a.lessons[0].entityId).indexOf(applicant.lessons[0].entityId);
      const updatedApplicants = [
        ...applicants.slice(0, i),
        Object.assign(applicants[i], {selected: !applicants[i].selected}),
        ...applicants.slice(i + 1),
      ];
      this.props.updateApplicants(updatedApplicants);
    };

    const sortable = sort.sort({
      getSortingColumns,
      onSort: selectedColumn => {
        this.setState({
          sortingColumns: sort.byColumn({
            sortingColumns: this.state.sortingColumns,
            selectedColumn
          })
        });
      },
      strategy: sort.strategies.byProperty
    });

    const columns = [
      hasRole(this.props.loggedUser, [
        "KULTU_SEURANTA_ADMIN",
        "KULTU_SEURANTA_KIRJAAJA",
      ]) && {
        property: "selected",
        props: {
          style: {
            width: "2em",
          },
        },
        cell: {
          formatters: [
            (value, props) => {
              return (
                <PvRadioButton
                  defaultChecked={value}
                  onChange={() => {
                    toggleSelection(props.rowData);
                  }}
                />
              );
            },
          ],
          transforms: [
            (value, props) => {
              if (!props.rowData.hasOwnProperty("selected")) {
                Object.assign(props.rowData, { selected: false });
              }
            },
          ],
        },
      },
      {
        property: "lastName",
        header: {
          label: (
            <Flex alignItems="center" justifyContent="space-between">
              <Translate value="app.name" />
              <PvCaret />
            </Flex>
          ),
          transforms: [sortable],
          formatters: [
            sort.header({
              sortable,
              getSortingColumns: getSortingColumns,
              strategy: sort.strategies.byProperty,
            }),
          ],
        },
        cell: {
          formatters: [
            (value, props) => {
              const name = [value, props.rowData.firstNames].join(" ");
              return (
                <ApplicantName title={name} >
                  <span>{name}</span>
                </ApplicantName>
              );
            },
          ],
        },
      },
      {
        property: "lessonDescription",
        header: {
          label: (
            <Flex alignItems="center" justifyContent="space-between">
              <Translate value="datatable.undone_entry" />
              <PvCaret />
            </Flex>
          ),
          transforms: [sortable],
          formatters: [
            sort.header({
              sortable,
              getSortingColumns: getSortingColumns,
              strategy: sort.strategies.byProperty,
            }),
          ],
        },
        cell: {
          formatters: [
            (_value, props) => (
              <Flex flexWrap="wrap">
                {(props.rowData.lessons || []).map((entry, idx, arr) => (
                  <Flex
                    id={entry.correlationId}
                    title={entry.lesson.description}
                    mr={[1]}
                  >
                    {formatShortLessonDescription(entry.lesson.description) + jsxJoinWith(idx, arr, ",") }
                  </Flex>
                  
                ))}
              </Flex>
            ),
          ],
        },
      },
    ].filter((c) => c !== false);

    this.state = {
      // Default sorting
      sortingColumns: {
        'lastName': {
          direction: 'asc',
          position: 0
        },
      },
      columns,
      rows: resolve.resolve(
        {
          columns,
          method: resolve.nested
        }
      )(this.props.rows || [])
    };
  }

  componentWillReceiveProps(props) {
    this.setState({
      rows: resolve.resolve(
        {
          columns: this.state.columns,
          method: resolve.nested
        }
      )(props.rows || [])
    });
  }

  render() {

    const {
      stylingRenderers,
    } = this.props;

    const {sortingColumns, columns, rows} = this.state;
    const finalRows =
      sort.sorter({
        columns,
        sortingColumns,
        sort: orderBy,
        strategy: sort.strategies.byProperty
      })(rows);

    return (
      <Table.Provider
        renderers={stylingRenderers}
        columns={columns}>
        <Table.Header />
        <Table.Body rows={finalRows} rowKey={({rowData}) => rowData.trafiId} />
      </Table.Provider>
    );
  }
}

UndoneDataTable.propTypes = {
  rows: PropTypes.array,
  columns: PropTypes.array,
  stylingRenderers: PropTypes.object,
  getApplicant: PropTypes.func,
  user: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    loggedUser: state.userState.user
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  getApplicant: (id) => getApplicantAction(id),
  updateApplicants: (updatedApplicants) => updateApplicantsAction(updatedApplicants)
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UndoneDataTable);


// WEBPACK FOOTER //
// ./src/components/datatable/UndoneDataTable.jsx